import { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

//CKEditor5
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

//Services
import api from "@/services/api.service";
import { INITIAL_UPDATE_REQUEST, SAVE_UPDATE_SUCCESS } from "@/redux/types/updates.types";

//Styles
import classes from "../updates.module.scss";
import Fetching from "@/components/Fetching/Fetching";

function uploadAdapter(loader) {
	return {
		upload: async () => {
			const body = new FormData();
			const file = await loader.file;
			body.append("files[]", file);
			const response = await api.post("/admin/upload_images", body);
			return {
				default: response.url,
			};
		},
	};
}

function uploadPlugin(editor) {
	editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
		return uploadAdapter(loader);
	};
}

const UpdateForm = (props) => {
	const { loading } = useSelector((state) => state.update);

	let initialState = {
		title: "",
		tools: "",
		text: "",
		page: props.current_page,
	};

	const dispatch = useDispatch();
	const { addToast } = useToasts();
	const [update, setUpdate] = useState({ ...initialState });

	const handleInputChange = (e) => {
		e.preventDefault();
		const { name, value } = e.target;

		setUpdate({ ...update, [name]: value });
	};

	const handleCKEditor = (event, editor) => {
		const data = editor.getData();

		setUpdate({ ...update, text: data });
	};

	const handleSubmit = () => {
		dispatch({
			type: INITIAL_UPDATE_REQUEST,
		});

		const params = {
			title: update.title,
			text: update.text,
			tools: update.tools,
			page: 1,
		};

		api.post("/admin/add_update", params).then((response) => {
			addToast(response.message, {
				appearance: "success",
			});

			dispatch({
				type: SAVE_UPDATE_SUCCESS,
				payload: {
					updates: response.posts.updates.data,
				},
			});
			props.handleClose();

			setUpdate({ ...initialState });
		});
	};

	return (
		<Modal show={props.show} onHide={props.handleClose} backdrop="static" keyboard={false} size="lg" enforceFocus={false}>
			<Modal.Header closeButton>
				<Modal.Title>Agregar nueva actualización</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					{loading ? (
						<Fetching topMargin={"1em"} />
					) : (
						<>
							<Form.Group>
								<Form.Label>Titulo de la actualizacion</Form.Label>
								<Form.Control
									type="text"
									placeholder="Ej: Nueva Actualización"
									className={`${classes.title_input}`}
									name="title"
									onChange={handleInputChange}
								/>
							</Form.Group>
							<Form.Group>
								<CKEditor
									editor={ClassicEditor}
									onChange={handleCKEditor}
									config={{
										licenseKey: "GPL",
										extraPlugins: [uploadPlugin],
										mediaEmbed: {
											previewsInData: true,
										},
									}}
								/>
							</Form.Group>
							<Form.Group>
								<Select
									value={props.tools.filter((tool) => update.tools.split(",").includes(String(tool.value)))}
									isMulti
									placeholder={<div>Seleccione</div>}
									options={props.tools || []}
									onChange={(value) => {
										const values_string = value.map((v) => v.value).join(",");
										setUpdate({ ...update, tools: values_string });
									}}
								/>
							</Form.Group>
							<Button onClick={handleSubmit}>Guardar</Button>
						</>
					)}
				</Form>
			</Modal.Body>
		</Modal>
	);
};

export default UpdateForm;
